const $inject = ['$rootScope', '$scope', '$routeParams', '$timeout', 'dataService'];

const lbaDateCtrl = function ($rootScope, $scope, $routeParams, $timeout, dataService) {
  let vm = this;

  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  let minDateLookup = [];
  let maxDateLookup = [];

  if(vm.settings.minDateAt){
    minDateLookup = dataService.spiltDataAt(vm.settings.minDateAt, $routeParams);
  }else if(vm.settings.maxDateAt){
    maxDateLookup = dataService.spiltDataAt(vm.settings.maxDateAt, $routeParams);
  }

  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.open = open;

  vm.dateFormat = 'yyyy-MM-dd';

  vm.status = {
    opened: !!vm.settings.showDatePickerOpened
  };
  
  vm.dateOptions = {
    formatYear: vm.settings.formatYear || 'yy',
    startingDay: vm.settings.startingDay || 0,
    showWeeks: !!vm.settings.showWeeks,
  };

  function open() {
    if(vm.settings.minDateAt){
      vm.minDate = _.get(dataService.data.activeItem, minDateLookup);
    }else if(vm.settings.maxDateAt){
      vm.maxDate = _.get(dataService.data.activeItem, maxDateLookup);
    }
    vm.status.opened = true;
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
      if (newData !== oldData) {
          let selectedDate = vm.settings.returnAsString ? newData.toLocaleString('sv').split(" ")[0] : newData;
          _.set(dataService.data.activeItem, dataLookUp, selectedDate);
      }
  });

  $rootScope.$on(vm.settings.dataAt, () => {
      $timeout(() => {
          vm.data = _.get(dataService.data.activeItem, dataLookUp);
      })
  });
};

lbaDateCtrl.$inject = $inject;

export default lbaDateCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaDate/lbaDateCtrl.js